<template>
  <SoWidget no-padding no-border plain>
    <div class="d-flex">
      <h4 class="text-h4 mb-10">Junifer Tickets</h4>
      <v-spacer />
      <SoCheckbox
        ref="junifer-filter-checkbox"
        v-model="showOpenTickets"
        :label="`Open Tickets`"
      />
    </div>
    <ActivityFeed
      ref="feed"
      :feed-item-list="filteredFeedItems"
      :pagination-reset-key="String(showOpenTickets)"
      :is-loading="isLoading"
      disable-routes
      height="calc(100vh - 200px)"
    />
  </SoWidget>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { IItemsByDate } from "@/models/activityFeed/ActivityFeedItem"
  import { mapState } from "pinia"
  import { Utility } from "@/types/Utility"
  import { JuniferTicket } from "@/models/juniferTickets/juniferTicket"
  import SoWidget from "@/components/SoWidget.vue"
  import ActivityFeed from "../../timeline/activityFeed/ActivityFeed.vue"
  import SoCheckbox from "@/components/formControls/SoCheckbox.vue"

  export default defineComponent({
    components: {
      SoWidget,
      ActivityFeed,
      SoCheckbox,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        selectedJuniferTicketId: null,
        showOpenTickets: true,
      }
    },
    computed: {
      ...mapState(useCurrentAccountStore, ["account", "activityFeedEvents"]),
      filteredFeedItems(): IItemsByDate[] {
        const filtered: IItemsByDate[] = []
        for (const event of this.activityFeedEvents.data) {
          filtered.push({
            date: event.date,
            items: event.items
              .filter((ticket) => [Utility.Junifer].includes(ticket.type))
              .filter(
                (ticket) =>
                  !this.showOpenTickets ||
                  (ticket.item as JuniferTicket).isOpen,
              ),
          })
        }

        return filtered.filter((date) => date.items.length !== 0)
      },
      isLoading() {
        return this.activityFeedEvents.isFetching
      },
    },
  })
</script>
